import { useEffect } from "react"

import { setCampaignId } from "../../utils/url-params"

const useSetCampaignId = () => {
  useEffect(() => {
    setCampaignId()
  }, [])
}

export default useSetCampaignId
